import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getDatabase, ref, push, onValue, get, set, update, remove, query, orderByChild, equalTo, off } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile, signOut } from 'firebase/auth';


// const firebaseConfig = {
//   apiKey: "AIzaSyDhkaJNr2MQoUxlH-vOBeD0DsWJAMQppZg",
//   authDomain: "billing-software-2cb29.firebaseapp.com",
//   databaseURL: "https://billing-software-2cb29-default-rtdb.firebaseio.com",
//   projectId: "billing-software-2cb29",
//   storageBucket: "billing-software-2cb29.firebasestorage.app",
//   messagingSenderId: "491034918907",
//   appId: "1:491034918907:web:c9c61c61a6e263180cd55e",
//   measurementId: "G-7G8TLS906"
// };


// const firebaseConfig = {
//   apiKey: "AIzaSyCXO74NOJ3ohdBWxbvTczrBQ0EMkALtSP8",
//   authDomain: "abcd-e4d73.firebaseapp.com",
//   databaseURL: "https://abcd-e4d73-default-rtdb.firebaseio.com",
//   projectId: "abcd-e4d73",
//   storageBucket: "abcd-e4d73.firebasestorage.app",
//   messagingSenderId: "620973234648",
//   appId: "1:620973234648:web:e0ddcd6c80c1b784207aad",
//   measurementId: "G-83J5WGPK41"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCZV65BUnu0VRbM9EaDvn-rq3gPl7omoGM",
  authDomain: "emplyeemanagementsystem-2380d.firebaseapp.com",
  databaseURL: "https://emplyeemanagementsystem-2380d-default-rtdb.firebaseio.com",
  projectId: "emplyeemanagementsystem-2380d",
  storageBucket: "emplyeemanagementsystem-2380d.appspot.com",
  messagingSenderId: "137213832204",
  appId: "1:137213832204:web:ca626e79231f67ff241229",
  measurementId: "G-XG5RBS2KXR"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const database = getDatabase(app);
const storage = getStorage(app);
const auth = getAuth(app);

// Export all needed Firebase features
export {
  app,
  db,
  database,
  storage,
  auth,
  ref,
  push,
  onValue,
  get,
  query,
  orderByChild,
  equalTo,
  set,
  update,
  remove, // Added this export
  off,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
  signOut
};